export default [
'Quebec',
'Northwest Territories',
'Ontario',
'Nunavut',
'Manitoba',
'Saskatchewan',
'Newfoundland and Labrador',
'British Columbia',
'Alberta',
'Yukon',
'Nova Scotia',
'New Brunswick',
'Prince Edward Island',
];


// WEBPACK FOOTER //
// ./resources/assets/js/canada-provinces.js